// The seven backdated essays, in publish order — the reader's first path through Field Notes.
export const START_HERE = [
  { slug: "voice-first-shadow-work-journal", title: "How to Start a Shadow Work Journal Without Writing a Single Word" },
  { slug: "shadow-work-prompts-by-chapter", title: "Shadow Work Prompts by Chapter: One Question for Each Stage" },
  { slug: "first-month-shadow-work-journal", title: "Shadow Work Journal: What the First Month Actually Looks Like" },
  { slug: "start-shadow-work-inner-child", title: "How to Start Shadow Work: Begin With the Inner Child" },
  { slug: "rumination-vs-shadow-work", title: "The Difference Between Rumination and Shadow Work" },
  { slug: "forgive-without-reconciliation", title: "How to Forgive Someone Without Letting Them Back In" },
  { slug: "relationship-coaching-for-men", title: "Relationship Coaching for Men: What Nobody Ever Taught You About Being Close" },
];

export const MEN_PATH = [
  { slug: "relationship-coaching-for-men", title: "Relationship Coaching for Men: What Nobody Ever Taught You About Being Close" },
  { slug: "anger-is-a-map-not-a-verdict", title: "The Good Person's Anger: What Your Temper Is Protecting" },
  { slug: "anger-is-the-map-not-the-monster", title: "Reading Anger Without Acting On It" },
  { slug: "the-mask-you-forgot-you-were-wearing", title: "The Mask You Forgot You Were Wearing" },
  { slug: "forgive-without-reconciliation", title: "How to Forgive Someone Without Letting Them Back In" },
  { slug: "when-you-open-your-mouth-and-nothing-makes-sense-yet", title: "When You Open Your Mouth and Nothing Makes Sense Yet" },
];

export const PATHS = [
  { id: "start-here", name: "Start here", lead: "New to shadow work? Read these seven in order.", essays: START_HERE },
  { id: "men-anger-closeness", name: "Men, anger & closeness", lead: "For men, and anyone handed few tools for anger and closeness.", essays: MEN_PATH },
];

export const startHereIndex = (slug) => START_HERE.findIndex((s) => s.slug === slug);
export const pathsFor = (slug) =>
  PATHS.map((path) => ({ path, index: path.essays.findIndex((e) => e.slug === slug) })).filter((x) => x.index >= 0);

const READ_KEY = "umbra_start_here_read";
export const NEWSLETTER_KEY = "umbra_newsletter_subscribed";
export const PROGRESS_EVENT = "umbra-path-progress";

export function readSlugs() {
  try {
    return new Set(JSON.parse(window.localStorage.getItem(READ_KEY) || "[]"));
  } catch {
    return new Set();
  }
}

export function writeRead(list) {
  try {
    window.localStorage.setItem(READ_KEY, JSON.stringify([...new Set(list)]));
  } catch {
    return;
  }
  window.dispatchEvent(new Event(PROGRESS_EVENT));
}

export function markRead(slug) {
  if (!pathsFor(slug).length) return;
  const s = readSlugs();
  if (s.has(slug)) return;
  s.add(slug);
  try {
    window.localStorage.setItem(READ_KEY, JSON.stringify([...s]));
  } catch {
    return;
  }
  window.dispatchEvent(new Event(PROGRESS_EVENT));
}

export function nextUnread(read, essays = START_HERE) {
  const i = essays.findIndex((s) => !read.has(s.slug));
  return i < 0 ? null : { ...essays[i], number: i + 1 };
}
